import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Main from './Main';

function mapStateToProps(state) {
	return {
		header: state.header,
		locations: state.locations,
		cycleRoutes: state.cycleRoutes,
		cycleHire: state.cycleHire,
		currentJourney: state.currentJourney,
		leisureRides: state.leisureRides,
		LCN: state.LCN,
		SR: state.SR,
		SUS: state.SUS,
		POI: state.POI,
		map: state.map,
		errors: state.errors,
		sidebar: state.sidebar,
		filters: state.filters,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(actions, dispatch);
}

const App = connect(mapStateToProps, mapDispatchToProps)(Main);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js